export default "__VITE_ASSET__7d09a7f1__"